export const ROLES = {
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  MEMBER: 'Member',
  CLIENT: 'Client',
};

export const isAdmin = (user) => user?.role === ROLES.ADMIN;
export const isManager = (user) => user?.role === ROLES.MANAGER;
export const isMember = (user) => user?.role === ROLES.MEMBER;
export const isScopedUser = (user) => isMember(user) || user?.role === ROLES.CLIENT;

export const canCreate = (user) => isAdmin(user) || isManager(user);
// Editing is reserved for administrators. Managers can create and view only.
export const canUpdate = (user) => isAdmin(user);
export const canDelete = (user) => isAdmin(user);

const ALL_NAV = [
  { to: '/app', label: 'Dashboard', iconKey: 'dashboard', exact: true },
  { to: '/app/ai-dashboard', label: 'AI Dashboard', iconKey: 'ai' },
  { to: '/app/projects', label: 'Projects', iconKey: 'projects' },
  { to: '/app/tasks', label: 'Tasks', iconKey: 'tasks' },
  { to: '/app/board', label: 'Board', iconKey: 'board', roles: ['Admin', 'Manager'] },
  { to: '/app/availability', label: 'Availability', iconKey: 'availability', roles: ['Admin', 'Manager'] },
  { to: '/app/sprints', label: 'Plan Sprint', iconKey: 'sprints', roles: ['Admin', 'Manager'] },
  { to: '/app/clients', label: 'Clients', iconKey: 'customers', roles: ['Admin', 'Manager'] },
  { to: '/app/leads', label: 'Leads', iconKey: 'leads', roles: ['Admin', 'Manager'] },
  { to: '/app/deals', label: 'Deals', iconKey: 'deals', roles: ['Admin', 'Manager'] },
  { to: '/app/timelogs', label: 'Time Logs', iconKey: 'timelogs', roles: ['Admin', 'Manager'] },
  { to: '/app/activities', label: 'Activities', iconKey: 'activities', roles: ['Admin', 'Manager'] },
  { to: '/app/users', label: 'Team', iconKey: 'users' },
  { to: '/app/chat', label: 'Chat', iconKey: 'chat' },
  { to: '/app/notifications', label: 'Notifications', iconKey: 'notifications' },
  { to: '/app/feedback', label: 'Feedback', iconKey: 'feedback', roles: ['Admin', 'Manager', 'Client'] },
  { to: '/app/project-activity-log', label: 'Activity Log', iconKey: 'project_activity_log', roles: ['Admin'] },
  { to: '/app/reports', label: 'Reports', iconKey: 'reports', roles: ['Admin', 'Manager'] },
  { to: '/app/webhooks', label: 'Webhooks', iconKey: 'webhooks', roles: ['Admin'] },
];

export const MEMBER_BLOCKED_PATHS = [
  '/app/board',
  '/app/availability',
  '/app/sprints',
  '/app/clients',
  '/app/leads',
  '/app/deals',
  '/app/timelogs',
  '/app/activities',
  '/app/project-activity-log',
  '/app/reports',
  '/app/webhooks',
];

export const getNavItemsForRole = (role) =>
  ALL_NAV.filter((item) => !item.roles || item.roles.includes(role));

export const canAccessPath = (role, path) => {
  if (!role) return false;
  if (role === ROLES.MEMBER || role === ROLES.CLIENT) {
    return !MEMBER_BLOCKED_PATHS.some(
      (blocked) => path === blocked || path.startsWith(`${blocked}/`)
    );
  }
  return true;
};
